import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { videos } from '@/mocks/videos';

const colorMap: Record<string, string> = {
  accent: 'bg-accent-500/15 text-accent-400',
  secondary: 'bg-secondary-500/15 text-secondary-600',
  primary: 'bg-primary-500/15 text-primary-400',
};

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-8 mt-12 md:mt-16">
      <div className="flex items-end justify-between mb-5 md:mb-7">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">浏览分类</h2>
          <p className="mt-1 text-sm text-foreground-600">按兴趣快速找到你想看的内容</p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {categories.map((c) => {
          const count = videos.filter((v) => v.categoryId === c.id).length;
          return (
            <Link
              key={c.id}
              to={`/category/${c.id}`}
              className="group bg-background-100 border border-background-200 rounded-lg p-4 md:p-5 hover:border-primary-400 transition-colors"
            >
              <span
                className={`w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg text-xl md:text-2xl ${colorMap[c.color] ?? colorMap.primary}`}
              >
                <i className={c.icon}></i>
              </span>
              <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-400 transition-colors">
                {c.name}
              </h3>
              <p className="mt-1 text-xs text-foreground-600 line-clamp-2 leading-relaxed">{c.description}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs text-accent-400">
                <i className="ri-play-list-2-line"></i>
                {count} 个视频
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}